<template>
    <div
        v-if="subscriptions"
        class="container-fluid userGroupSubscriptionsWrapper">
        <div class="d-block d-md-flex justify-content-between mb-3">
            <div class="d-block d-md-flex flex-wrap align-items-center">
                <div class="mt-2 mr-0 mb-2 mr-md-2 mb-md-0">
                    <div class="input-group input-group-sm">
                        <select
                            v-model="search.plan_id"
                            @change="onChangeSearchPlanId"
                            id="status"
                            style="min-width: 100px;"
                            class="form-control">
                            <option :value="null">サービスで検索</option>
                            <option
                                v-for="plan in doctorPassPlans"
                                :value="plan.id">
                                {{ plan.name }}
                            </option>
                        </select>
                    </div>
                </div>

                <div class="mt-2 mr-0 mb-2 mr-md-2 mb-md-0">
                    <div class="input-group input-group-sm">
                        <select
                            v-model="search.status"
                            @change="onChangeSearchStatus"
                            id="status"
                            style="min-width: 100px;"
                            class="form-control">
                            <option :value="null">ステータスで検索</option>
                            <option
                                v-for="status in subscriptionStatus.common"
                                :value="status.value">
                                {{ status.text }}
                            </option>
                        </select>
                    </div>
                </div>

                <div class="d-block d-md-flex align-items-center">
                    <div class="mt-2 mb-2 ml-md-2 mb-md-0">
                        <span class="small">出国日</span>
                    </div>
                    <div class="mt-2 mb-2 ml-md-2 mb-md-0">
                        <div class="input-group input-group-sm">
                            <input
                                v-model="search.period_start_gte"
                                @change="onChangeSearchPeriodStartGte"
                                type="date"
                                class="form-control"
                                style="min-width: 100px;">
                        </div>
                    </div>
                    <span class="small mt-2 ml-2">〜</span>
                    <div class="mt-2 mb-2 ml-md-2 mb-md-0">
                        <div class="input-group input-group-sm">
                            <input
                                v-model="search.period_start_lte"
                                @change="onChangeSearchPeriodStartLte"
                                type="date"
                                class="form-control"
                                style="min-width: 100px;">
                        </div>
                    </div>
                </div>

                <div class="d-block d-md-flex align-items-center">
                    <div class="mt-2 mb-2 ml-md-2 mb-md-0">
                        <span class="small">帰国日</span>
                    </div>
                    <div class="mt-2 mb-2 ml-md-2 mb-md-0">
                        <div class="input-group input-group-sm">
                            <input
                                v-model="search.period_end_gte"
                                @change="onChangeSearchPeriodEndGte"
                                type="date"
                                class="form-control"
                                style="min-width: 100px;">
                        </div>
                    </div>
                    <span class="small mt-2 ml-2">〜</span>
                    <div class="mt-2 mb-2 ml-md-2 mb-md-0">
                        <div class="input-group input-group-sm">
                            <input
                                v-model="search.period_end_lte"
                                @change="onChangeSearchPeriodEndLte"
                                type="date"
                                class="form-control"
                                style="min-width: 100px;">
                        </div>
                    </div>
                </div>

                <div class="d-block d-md-flex align-items-center">
                    <div class="mt-2 mb-2 ml-md-2 mb-md-0">
                        <span class="small">キャンセル日</span>
                    </div>
                    <div class="mt-2 mb-2 ml-md-2 mb-md-0">
                        <div class="input-group input-group-sm">
                            <input
                                v-model="search.canceled_at_gte"
                                @change="onChangeSearchCanceledAtGte"
                                type="date"
                                class="form-control"
                                style="min-width: 100px;">
                        </div>
                    </div>
                    <span class="small mt-2 ml-2">〜</span>
                    <div class="mt-2 mb-2 ml-md-2 mb-md-0">
                        <div class="input-group input-group-sm">
                            <input
                                v-model="search.canceled_at_lte"
                                @change="onChangeSearchCanceledAtLte"
                                type="date"
                                class="form-control"
                                style="min-width: 100px;">
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row justify-content-center">
            <div class="col-md-12">
                <b-table
                    striped
                    hover
                    responsive
                    :items="subscriptions"
                    :fields="fields"
                    :sort-by.sync="morphState.sortBy"
                    :sort-desc.sync="morphState.sortDesc"
                    @sort-changed="fetchSubscriptions"
                    class="table-bordered m-table">
                    <template v-slot:cell(join_users.full_name_kana)="data">
                        <template v-if="data.item.user">
                            <div>{{ data.item.user.full_name }}</div>
                            <div class="small">{{ data.item.user.full_name_kana }}</div>
                            <span class="text-muted small">#{{ data.item.user_id }}</span>
                        </template>
                        <template v-else>
                            <span class="text-muted">退会済の{{ $locale.patient }}</span>
                        </template>
                    </template>

                    <template v-slot:cell(plan_id)="data">
                        <div>{{ data.item.plan.name }}</div>
                    </template>

                    <template v-slot:cell(period_start)="data">
                        <span class="u-palt">
                            {{ helper.dateForHuman(data.item.period_start, timezoneAsia, { exceptYear: helper.isCurrentYear(data.item.period_start, timezoneAsia), simpleYear: true }) }}
                        </span>
                        <span
                            class="u-palt"
                            :class="helper.dayForHumanCSS(data.item.period_start , timezoneAsia)">
                            {{ helper.dayForHuman(data.item.period_start, timezoneAsia, { bracket: true }) }}
                        </span>
                    </template>

                    <template v-slot:cell(period_end)="data">
                        <span class="u-palt">
                            {{ helper.dateForHuman(data.item.period_end, timezoneAsia, { exceptYear: helper.isCurrentYear(data.item.period_end, timezoneAsia), simpleYear: true }) }}
                        </span>
                        <span
                            class="u-palt"
                            :class="helper.dayForHumanCSS(data.item.period_end , timezoneAsia)">
                            {{ helper.dayForHuman(data.item.period_end, timezoneAsia, { bracket: true }) }}
                        </span>
                    </template>

                    <template v-slot:cell(status)="data">
                        <div v-if="data.item.status === subscriptionStatus.notStarted" class="text-muted">{{ data.item.status_label }}</div>
                        <div v-else-if="data.item.status === subscriptionStatus.active" class="text-success">{{ data.item.status_label }}</div>
                        <div v-else-if="data.item.status === subscriptionStatus.paused" class="text-danger">{{ data.item.status_label }}</div>
                        <div v-else>{{ data.item.status_label }}</div>
                        <div v-if="data.item.canceled_at" class="text-muted small">
                            {{ `キャンセル日時: ${helper.dateTimeForHuman(data.item.canceled_at, timezoneAsia)}` }}
                        </div>
                    </template>

                    <template v-slot:cell(links)="data">
                        <div
                            v-if="isStatusActive(data.item)"
                            v-b-tooltip.top
                            title="利用中はキャンセルできません"
                            tabindex="0">
                            <b-button
                                size="sm"
                                variant="yokumiru-gray"
                                style="pointer-events: none;"
                                disabled>
                                キャンセル
                            </b-button>
                        </div>
                        <div v-else-if="isStatusNotStarted(data.item)">
                            <b-button
                                size="sm"
                                variant="yokumiru-gray"
                                @click="onClickCancel(data.item)">
                                キャンセル
                            </b-button>
                        </div>
                    </template>
                </b-table>

                <div class="d-flex flex-wrap justify-content-between align-items-center">
                    <b-pagination
                        :total-rows="morphState.total"
                        :per-page="morphState.per_page"
                        v-model="morphState.current_page"
                        @change="fetchSubscriptions">
                    </b-pagination>

                    <div class="d-flex flex-wrap align-items-center">
                        <div class="mr-3 mb-3">
                            <span class="small">{{ dispPaginationDetail }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <doctor-menu-modal user-type="user"/>
        <doctor-profile-modal/>
        <subscription-cancel-modal is-group is-admin/>
    </div>
</template>

<script>
import { mapMutations } from 'vuex'
import constants from '../../../constants'
import YokumiruHelper from '../../../YokumiruHelper'

export default {
    props: {
        timezone: {
            type: String,
            default: 'Asia/Tokyo',
        },
        group: {
            type: Object,
            required: true,
        },
    },

    data: function () {
        return {
            helper: YokumiruHelper,
            search: {
                plan_id: null,
                status: null,
                period_start_gte: null,
                period_start_lte: null,
                period_end_gte: null,
                period_end_lte: null,
                canceled_at_gte: null,
                canceled_at_lte: null,
            },
            subscriptions: null,
            subscriptionStatus: constants.subscriptions,
            inProgress: false,
            errors: {},
            fields: [
                {
                    key: 'id',
                    label: '#',
                    sortable: true,
                },
                {
                    key: 'join_users.full_name_kana',
                    label: this.$locale.patient,
                    sortable: true,
                },
                {
                    key: 'plan_id',
                    label: 'サービス',
                    sortable: true,
                },
                {
                    key: 'period_start',
                    label: '出国日（日本時間）',
                    sortable: true,
                },
                {
                    key: 'period_end',
                    label: '帰国日（日本時間）',
                    sortable: true,
                },
                {
                    key: 'status',
                    label: 'ステータス',
                    sortable: true,
                },
                {
                    key: 'links',
                    label: '',
                    class: 'text-center',
                    sortable: false,
                },
            ],
        }
    },

    computed: {
        timezoneAsia: function () {
            return 'Asia/Tokyo'
        },

        isCompany: function () {
            return this.helper.isCompany(this.group)
        },

        isOrganization: function () {
            return this.helper.isOrganization(this.group)
        },

        doctorPassPlans: function () {
            return this.group.plans.filter((plan) => this.helper.isDoctorPass(plan))
        },

        morphState: function () {
            if (this.isCompany) {
                return this.$store.state.adminCompanySubscriptions
            }
            else if (this.isOrganization) {
                return this.$store.state.adminOrganizationSubscriptions
            }
            return null
        },

        /**
         * ページング詳細表示
         * @returns {string}
         */
        dispPaginationDetail: function () {
            if (this.morphState.total < 1) return ''
            return `全${this.morphState.total}件中 ${this.morphState.from}～${this.morphState.to}件表示`
        },
    },

    created: function () {
        this.initQueryFromState()
        this.initSearchCondition()
        this.fetchSubscriptions()

        bus.$on('subscription-canceled', this.fetchSubscriptions)
    },

    beforeDestroy: function () {
        bus.$off('subscription-canceled')
    },

    methods: {
        ...mapMutations({
            setQueryCompany: 'adminCompanySubscriptions/setQuery',
            setQueriesCompany: 'adminCompanySubscriptions/setQueries',
            clearQueriesCompany: 'adminCompanySubscriptions/clearQueries',
            setQueryOrganization: 'adminOrganizationSubscriptions/setQuery',
            setQueriesOrganization: 'adminOrganizationSubscriptions/setQueries',
            clearQueriesOrganization: 'adminOrganizationSubscriptions/clearQueries',
        }),

        setQuery: function (data) {
            if (this.isOrganization) {
                this.setQueryOrganization(data)
            }
            else if (this.isCompany) {
                this.setQueryCompany(data)
            }
        },

        setQueries: function (data) {
            if (this.isOrganization) {
                this.setQueriesOrganization(data)
            }
            else if (this.isCompany) {
                this.setQueriesCompany(data)
            }
        },

        clearQueries: function () {
            if (this.isOrganization) {
                this.clearQueriesOrganization()
            }
            else if (this.isCompany) {
                this.clearQueriesCompany()
            }
        },

        /**
         * 検索条件の初期化
         */
        initQueryFromState: function () {
            if (localStorage.getItem('yokumiruWeb')) {
                const data = JSON.parse(localStorage.getItem('yokumiruWeb'))
                if (this.isCompany && data.adminCompanySubscriptions) {
                    this.setQueries(data.adminCompanySubscriptions)
                }
                else if (this.isOrganization && data.adminOrganizationSubscriptions) {
                    this.setQueries(data.adminOrganizationSubscriptions)
                }
            }
        },

        /**
         * 検索条件の初期化
         */
        initSearchCondition: function () {
            this.search.plan_id = this.morphState.plan_id
            this.search.status = this.morphState.status
            this.search.period_start_gte = this.morphState.period_start_gte
            this.search.period_start_lte = this.morphState.period_start_lte
            this.search.period_end_gte = this.morphState.period_end_gte
            this.search.period_end_lte = this.morphState.period_end_lte
            this.search.canceled_at_gte = this.morphState.canceled_at_gte
            this.search.canceled_at_lte = this.morphState.canceled_at_lte
        },

        onChangeSearchPlanId: async function () {
            await this.setQuery({ key: 'plan_id', value: this.search.plan_id })
            await this.fetchSubscriptions(1)
        },

        onChangeSearchStatus: async function () {
            await this.setQuery({ key: 'status', value: this.search.status })
            await this.fetchSubscriptions(1)
        },

        onChangeSearchPeriodStartGte: async function () {
            await this.setQuery({ key: 'period_start_gte', value: this.search.period_start_gte })
            await this.fetchSubscriptions(1)
        },

        onChangeSearchPeriodStartLte: async function () {
            await this.setQuery({ key: 'period_start_lte', value: this.search.period_start_lte })
            await this.fetchSubscriptions(1)
        },

        onChangeSearchPeriodEndGte: async function () {
            await this.setQuery({ key: 'period_end_gte', value: this.search.period_end_gte })
            await this.fetchSubscriptions(1)
        },

        onChangeSearchPeriodEndLte: async function () {
            await this.setQuery({ key: 'period_end_lte', value: this.search.period_end_lte })
            await this.fetchSubscriptions(1)
        },

        onChangeSearchCanceledAtGte: async function () {
            await this.setQuery({ key: 'canceled_at_gte', value: this.search.canceled_at_gte })
            await this.fetchSubscriptions(1)
        },

        onChangeSearchCanceledAtLte: async function () {
            await this.setQuery({ key: 'canceled_at_lte', value: this.search.canceled_at_lte })
            await this.fetchSubscriptions(1)
        },

        /**
         * ドクターパス利用一覧取得
         *
         * @param {number|object} param
         */
        fetchSubscriptions: async function (param = null) {
            if (this.inProgress) return
            this.inProgress = true

            this.subscriptions = null

            if (Number.isInteger(param) && param > 0) {
                await this.setQuery({ key: 'current_page', value: param })
            }
            else if (param !== null && param.hasOwnProperty('sortBy')) {
                await this.setQuery({ key: 'sortBy', value: param.sortBy })
                await this.setQuery({ key: 'sortDesc', value: param.sortDesc })
            }

            const endpoint = constants.admin.subscriptions.endpoint.base

            await axios.get(`${endpoint}${this.buildQuery()}&group_id=${this.group.id}`)
                .then(({data}) => {
                    this.subscriptions = data.data
                    this.setQueries(data.meta)
                })
                .catch(({response}) => {
                    if (response.status === 422) {
                        this.clearQueries()
                    }
                })

            this.inProgress = false
        },

        /**
         * QueryString生成
         *
         * @param {boolean} paginate
         * @return {string}
         */
        buildQuery: function (paginate = true) {
            let query = '?'

            const state = this.morphState

            if (paginate) {
                query += `page=${state.current_page}`
                query += `&sort=${state.sortBy}`
                query += `&desc=${state.sortDesc}`
            }
            else {
                query += `sort=${state.sortBy}`
                query += `&desc=${state.sortDesc}`
            }

            if (state.plan_id) {
                query += `&plan_id=${state.plan_id}`
            }
            if (state.status) {
                query += `&status=${state.status}`
            }
            if (state.period_start_gte) {
                query += `&period_start_gte=${state.period_start_gte}`
            }
            if (state.period_start_lte) {
                query += `&period_start_lte=${state.period_start_lte}`
            }
            if (state.period_end_gte) {
                query += `&period_end_gte=${state.period_end_gte}`
            }
            if (state.period_end_lte) {
                query += `&period_end_lte=${state.period_end_lte}`
            }
            if (state.canceled_at_gte) {
                query += `&canceled_at_gte=${state.canceled_at_gte}`
            }
            if (state.canceled_at_lte) {
                query += `&canceled_at_lte=${state.canceled_at_lte}`
            }

            return query
        },

        /**
         * 利用中判定
         * @param {object} subscription
         * @return {boolean}
         */
        isStatusActive: function (subscription) {
            return this.helper.isStatusActive(subscription)
        },

        /**
         * 利用開始前判定
         * @param {object} subscription
         * @return {boolean}
         */
        isStatusNotStarted: function (subscription) {
            return this.helper.isStatusNotStarted(subscription)
        },

        /**
         * キャンセルボタン押下時
         * @param {object} subscription
         */
        onClickCancel: function (subscription) {
            bus.$emit('open-modal-subscription-cancel', subscription.user, subscription.plan, subscription)
        },
    },
}
</script>

<style lang="scss" scoped>
.repeatReservedLabel {
    position: relative;
    top: -1px;
    display: inline-block;
    width: 18px;
    height: 18px;
    line-height: 18px;
    color: #fff;
    font-size: 10px;
    text-align: center;
    background-color: #e7a222;
    border-radius: 50%;
}

.subscriptionTime {
    color: #464a4d;
    font-size: 14px;
    font-weight: bold;
    line-height: 1.4;
    font-feature-settings: 'palt';

    span:last-child {
        color: #6e7275;
        font-weight: normal;
    }
}

.doctorMenuHealthPackageIcon {
    margin: 3px 0 1px;

    img {
        width: 130px;
    }
}

.feedbackLabel {
    width: 90px;
    margin: 0 auto;
    padding: 3px 0;
    border-radius: 20px;
    color: #fff;
    font-size: 13px;
    text-align: center;
    box-sizing: border-box;
}

.feedbackNextSchedule {
    overflow-x: scroll;
    white-space: pre;
    width: 160px;
    padding: 0 0 5px;
}
</style>

<style lang="scss">
.userGroupSubscriptionsWrapper {
    table {
        min-width: 1400px;

        th, td {
            font-size: 0.75rem;
        }

        th {
            &:nth-child(9) {
                width: 140px;
            }

            &:nth-child(10) {
                width: 160px;
            }
        }
    }
}
</style>
